module.exports = __webpack_public_path__ + "img/how-two.add0e602.svg";